import { createEntityAdapter } from "@reduxjs/toolkit";

import apiSlice from "../api/apiSlice";
import { effectiveAtQuery, withBusinessValidity } from "../../utils/businessValidity";

const metersAdapter = createEntityAdapter({});

const initialState = metersAdapter.getInitialState({});

export const metersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /* GET */
    getMetersByCommunityId: builder.query({
      query: ({ communityId, excludeDeleted }) => ({
        url:
          `/communities/${communityId}/meters?` +
          `${excludeDeleted !== undefined ? `&exclude_deleted=${excludeDeleted}` : ""}`,
        method: "GET",
        validateStatus: (response, result) => response.status === 200 && !result?.isError,
      }),
      transformResponse: (responseData) => {
        if (responseData) {
          return metersAdapter.setAll(initialState, responseData);
        }
        return metersAdapter.setAll(initialState, []);
      },
      providesTags: (result) => {
        if (result?.ids) {
          return [
            { type: "Meter", id: "LIST" },
            ...result.ids.map((id) => ({ type: "Meter", id })),
          ];
        }
        return [{ type: "Meter", id: "LIST" }];
      },
    }),
    /* POST */
    addNewMeter: builder.mutation({
      query: (meter) => ({
        url: `/communities/${meter.community_id}/meters`,
        method: "POST",
        body: {
          ...withBusinessValidity(meter),
        },
      }),
      invalidatesTags: [
        { type: "Meter", id: "LIST" },
        { type: "RESP", id: "LIST" },
      ],
    }),
    /* UPDATE */
    updateMeterById: builder.mutation({
      query: ({ id, communityId, newMeter }) => ({
        url: `/communities/${communityId}/meters/${id}`,
        method: "PUT",
        body: {
          ...withBusinessValidity(newMeter),
        },
      }),
      invalidatesTags: (_, __, arg) => [
        { type: "Meter", id: arg.id },
        { type: "RESP", id: "LIST" },
      ],
    }),
    /* DELETE */
    deleteMeterById: builder.mutation({
      query: ({ communityId, id, effectiveAt }) => ({
        url: `/communities/${communityId}/meters/${id}?${effectiveAtQuery(effectiveAt)}`,
        method: "DELETE",
      }),
      invalidatesTags: (_, __, arg) => [
        { type: "Meter", id: arg.id },
        { type: "RESP", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useGetMetersByCommunityIdQuery,
  useAddNewMeterMutation,
  useUpdateMeterByIdMutation,
  useDeleteMeterByIdMutation,
} = metersApiSlice;

export const { selectAll: selectAllMeters } = metersAdapter.getSelectors();
